import cn from "classnames";
import "./LabelWithYears.scss";

export interface LabelWithYearsProps {
  years: string;
  text: string;
  className?: string;
}

export const LabelWithYears = ({
  years,
  text,
  className,
}: LabelWithYearsProps) => {
  return (
    <div className={cn(className, "label-with-years")}>
      <div className={`label-with-years__label ${!years ? 'label-with-years__label__invisible' : ''}`}>{years || '0000'}</div>
      <div className="label-with-years__text">{text}</div>
    </div>
  );
};
